import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetMeetingDetailsAsync, IMeetingDetails } from "../../api/IMeeting";
import { RootState } from "../store";

export interface MeetingState {
  fetchStatus: string;
  meeting?: IMeetingDetails;
}

const initialState: MeetingState = {
  fetchStatus: "Loading...",
  meeting: undefined,
};

export const loadMeetingAsync = createAsyncThunk(
  "meeting/load",
  async (meetingId: string) => {
    const response = await GetMeetingDetailsAsync(meetingId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const meetingSlice = createSlice({
  name: "meeting",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadMeetingAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadMeetingAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.meeting = action.payload;
      });
  },
});

export const selectMeeting = (state: RootState) => state.meeting;

export default meetingSlice.reducer;
